export class PhrasesData {
    public phrases: any = [];
    public fileUpdatedAt: string = "";
    public fileUrl: string = "";
    public lastChangedUserId: string = "";
    public updated_at: string = "";
    public user_updated: string = "";
}